<template>
  <div>
    <div class="body">
      <div class="image_area">
        <div class="image_upload" @click="handleImageUploadClick" @dragover.prevent @drop="handleImageDrop"
          v-loading="loading">
          <div class="tips"> 拖拽或点击上传图像</div>
          <img v-if="imagePath" :src="imagePath" alt="">
          <div v-if="imagePath" class="delete_image" @click.stop="deleteImage"> 清空图像</div>
          <div class="paste iconfont" @click.stop="warningTips">&#xe612; 粘贴</div>
        </div>
        <div class="gap"></div>
        <div class="parameters">
          <div class="document">
            <div class="top_tips_01 iconfont">&#xe605; 文档输入说明</div>
            <div class="video_tip" title="点击观看操作视频" @click="show_video">&nbsp;[点击观看操作视频]</div>
          </div>
          <span>动态模糊</span>
          <div class="activeblur">
            <div class="edit">
              <div class="iconfont">&#xe690; 角度</div>
              <input type="number" v-model="angle" min="0" max="90">
            </div>
            <div class="edit">
              <div class="iconfont">&#xe652; 模糊</div>
              <input type="number" v-model="blur_1" min="1" max="100">
            </div>
            <div class="edit">
              <div class="iconfont">&#xe658; 开关</div>
              <select name="" id="" v-model="bolean_1">
                <option :value="true">开启应用</option>
                <option :value="false">关闭应用</option>
              </select>
            </div>
          </div>
          <span>高斯模糊</span>
          <div class="blur">
            <div class="edit">
              <div class="iconfont">&#xe652; 模糊</div>
              <input type="number" v-model="blur_2" min="1" max="100">
            </div>
            <div class="edit">
              <div class="iconfont">&#xe658; 开关</div>
              <select name="" id="" v-model="bolean_2">
                <option :value="true">开启应用</option>
                <option :value="false">关闭应用</option>
              </select>
            </div>
          </div>
          <span>色彩调整</span>
          <div class="color">
            <div class="edit">
              <div class="iconfont">&#xe651; 亮度</div>
              <input type="number" v-model="brightness" min="0" max="3">
            </div>
            <div class="edit">
              <div class="iconfont">&#xe764; 对比</div>
              <input type="number" v-model="constrast" min="0" max="3">
            </div>
            <div class="edit">
              <div class="iconfont">&#xe654; 饱和</div>
              <input type="number" v-model="saturation" min="0" max="3">
            </div>
          </div>
          <span>人像柔光</span>
          <div class="portrait">
            <div class="edit">
              <div class="iconfont">&#xe863; 舒适</div>
              <input type="number" v-model="soft" min="0.2" max="10">
            </div>
            <div class="edit">
              <div class="iconfont">&#xe653; 阈值</div>
              <input type="number" v-model="threshold" min="0" max="255">
            </div>
            <div class="edit">
              <div class="iconfont">&#xe657; 透明</div>
              <input type="number" v-model="opacity" min="0" max="100">
            </div>
          </div>
          <div class="start iconfont" @click="start_process">&#xe632; 开始任务</div>
          <div class="disscuss_area">
            <div class="disscuss iconfont" @click="handelDissvisible(1)">&#xe67c; 讨论区</div>
            <div class="disscuss iconfont" @click="handelDissvisible(2)">&#xe66c; 返图区</div>
          </div>
        </div>
        <div class="gap"></div>
        <div class="panel">
          <div class="show iconfont">&#xe76d; 显示面板</div>
          <img v-if="processedImage" :src="processedImage" alt="">
          <div class="copy_path iconfont" title="复制图像地址" @click="copy_path(processedImage)">&#xe660; 复制</div>
          <div v-if="tips" class="tips">{{ tips }}</div>
          <div v-if="tips" class="mask"></div>
        </div>
      </div>
    </div>
    <ImageModal class="modal" :visible="isModalVisible" :img_url="imageUrl" @update:visible="isModalVisible = $event"
      :img_show="false" :video_show="true" :video_src="video_src">
    </ImageModal>
    <discussion-board class="discussion-board" :boardvisible="boardvisible" :disscussType="disscussType"
      @update:boardvisible="boardvisible = $event"></discussion-board>
  </div>
</template>
<script>
import { genOssImage } from '@/utils/ossPath'
import { v4 as uuidv4 } from 'uuid'
import random from 'random'
import { Message } from 'element-ui'
import { genPrompt } from '@/api/prompt'
import { getLastUsedBaseUrl, cudaIndexNum } from '@/utils/comfyUiRequest'
import axios from 'axios'
import cuda from '@/utils/checkCuda'
import { getOssClient } from '@/utils/oss'
import localStorageUtils from '@/utils/setLocalStorage'
import { getTaskEnd, getTaskStart } from '@/api/user'
import { EDIT_Image_PS } from '@/enums/common/modules'
import getImageDimensions from '@/utils/getImageDimensions'
import theme from '@/utils/theme'
import { OSS_ACCESS_KEY_ID, OSS_ACCESS_KEY_SECRET } from '@/utils/secretCrypto'
export default {
  name: 'EditImage',
  data() {
    return {
      taskLogId: '',
      value: false,
      imageSrc: '',
      imagePath: '',
      processedImage: '',
      tips: false,
      current: '',
      processing: false,
      websocket: null,
      ws: null,
      clientId: '',
      angle: 0,
      blur_1: 1,
      blur_2: 1,
      brightness: 1,
      constrast: 1,
      saturation: 1,
      soft: 1,
      threshold: 1,
      opacity: 80,
      bolean_1: false,
      bolean_2: false,
      loading: false,
      imageUrl: 'https://example.com/image.jpg',
      day: theme.day,
      night: theme.night,
      theme: true,
      // 防呆设计
      isModalVisible: false,
      img_show: false,
      video_src: '',
      // 评论区弹窗
      boardvisible: false,
      disscussType: null
    }
  },
  created() {
    this.imagePath = localStorageUtils.getItem('edit_picture')
    this.processedImage = localStorageUtils.getItem('edit_picture_showimage')
    // 将ID值赋给讨论区类型
    this.disscussType = EDIT_Image_PS
    // 获取主题
    if (localStorageUtils.getItem('theme') !== null) {
      this.theme = localStorageUtils.getItem('theme')
    } else {
      this.theme = true
    }
  },
  mounted() {
    // 添加键盘事件监听器
    window.addEventListener('keydown', this.handleKeystart)
    window.addEventListener('keydown', this.handleKeyPaste)
    // 重刷新释放cuda
    window.addEventListener('beforeunload', this.releaseCuda)
    this.$nextTick(() => {
      this.source_html()
    })
  },
  async beforeDestroy() {
    // 移除键盘事件监听器以防止内存泄漏
    window.removeEventListener('keydown', this.handleKeystart)
    window.removeEventListener('keydown', this.handleKeyPaste)
    try {
      // 释放cuda状态
      const index = await cudaIndexNum()
      if (index) {
        await cuda.changeCudaCurrentStatus(index, 'leisure')
        console.log('current cuda is leisure')
      }
    } catch (e) {
      console.log('no cuda is running')
    }
    // 移除cuda释放监听器
    window.removeEventListener('beforeunload', this.releaseCuda)
  },
  methods: {
    // 修改dissboard的状态
    handelDissvisible(x) {
      if (x === 1) {
        this.boardvisible = true
      }
      if (x === 2) {
        Message.warning('😋开发者功能暂未开放,敬请期待~!')
      }
    },
    // 释放cuda
    async releaseCuda() {
      try {
        // 释放cuda状态
        const index = await cudaIndexNum()
        if (index) {
          await cuda.changeCudaCurrentStatus(index, 'leisure')
          console.log('current cuda is leisure')
        }
      } catch (e) {
        console.log('no cuda is running')
      }
    },
    // 防呆设计
    show_video(event) {
      event.preventDefault()
      event.stopPropagation()
      this.isModalVisible = true
      this.video_src = 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/wan_move_show_video/PS%E5%9B%BE%E5%83%8F%E7%BC%96%E8%BE%91.mp4'
    },
    // 复制图像地址
    async copy_path(path) {
      if (!path) {
        Message.error('图像地址为空,请确认是否生成图像！')
        return
      }
      try {
        // 不兼容已弃用
        // await navigator.clipboard.writeText(path)

        // 兼容性更好
        const textarea = document.createElement('textarea')
        textarea.value = path
        textarea.style.position = 'fixed'
        textarea.style.opacity = '0'
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
        Message.success('复制内容成功,可进行下一步操作！')
      } catch {
        Message.error('复制内容失败,请稍后再试！')
      }
    },
    // 添加开始快捷键
    handleKeystart(event) {
      // 检查是否按下了 Ctrl + D
      if (event.ctrlKey && event.key === 'Enter') {
        event.preventDefault() // 阻止默认行为（可选）
        this.start_process() // 执行返回主页的操作
      }
    },
    gohome() {
      this.$router.push({ path: '/' })
    },
    warningTips() {
      Message.warning('由于浏览器安全协议,请使用Ctrl + V 快捷键进行图片粘贴')
    },
    // 添加 Ctrl+V 快捷键处理
    async handleKeyPaste(event) {
      // 检查是否按下了 Ctrl + V
      if (event.ctrlKey && event.key === 'v') {
        // event.preventDefault()
        try {
          const textarea = document.createElement('textarea')
          textarea.style.position = 'fixed'
          textarea.style.opacity = '0'
          document.body.appendChild(textarea)
          textarea.focus()
          // 创建一个Promise来等待粘贴事件完成
          const clipboardData = await new Promise((resolve, reject) => {
            textarea.addEventListener('paste', () => {
              setTimeout(() => {
                resolve(textarea.value)
              }, 10)
            })
            // 设置超时，防止永远等待
            setTimeout(() => {
              reject(new Error('粘贴操作超时'))
            }, 2000)
          })
          document.body.removeChild(textarea)
          // 使用正则表达式判断字符串是否以常见图片格式结尾
          const imageRegex = /\.(png|jpe?g|gif|bmp|webp)$/i
          if (!imageRegex.test(clipboardData)) {
            Message.error('剪切板中的内容不是有效的图片地址（支持的格式：.png, .jpg, .jpeg, .gif, .bmp, .webp)')
          } else {
            // console.log(clipboardData)
            this.imagePath = clipboardData
            localStorageUtils.setItem('edit_picture', clipboardData)
            Message.success('已从剪切板粘贴图片地址')
          }
        } catch (err) {
          Message.error('出现系统兼容性错误,请上报错误给开发者!')
        }
      }
    },
    // 上传图片到OSS
    async uploadToOSS(file, ossClient) {
      const tmp = '/input/'
      const fileName = file.name
      console.log('上传到OSS:', tmp + fileName)
      try {
        const result = await ossClient.put(tmp + fileName, file)
        return result.url
      } catch (err) {
        return null
      }
    },
    // 点击上传按钮
    handleImageUploadClick() {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'image/*'
      input.onchange = (event) => {
        const file = event.target.files[0]
        if (file) {
          this.processImage(file)
        }
      }
      input.click()
    },
    // 拖拽上传事件
    handleImageDrop(event) {
      event.preventDefault()
      const file = event.dataTransfer.files[0]
      if (file && file.type.startsWith('image/')) {
        this.processImage(file)
      } else {
        Message.error('请上传有效的图片文件')
      }
    },
    //  图片处理函数
    async processImage(file) {
      this.loading = true
      const ossClient = await getOssClient()
      // 上传图片到OSS
      const imageUrl = await this.uploadToOSS(file, ossClient)

      // 获取图片尺寸并加以限制
      try {
        const imageSize = await getImageDimensions(imageUrl)
        // console.log('图片尺寸:', imageSize.width, 'x', imageSize.height)
        if (imageSize.width > 1600 || imageSize.height > 1600) {
          Message.error('图片尺寸过大,请重新上传!建议分辨率为1600*1600以内')
          this.loading = false
          return
        }
      } catch (error) {
        Message.error('获取图片尺寸失败:', error)
      }

      if (imageUrl) {
        this.imagePath = imageUrl // 更新图片路径为OSS的URL
        console.log(imageUrl, typeof imageUrl)
        localStorageUtils.setItem('edit_picture', imageUrl)
        Message.success('图片加载成功,可以准备开始任务!')
      } else {
        Message.error('图片上传失败,请检查网络配置!')
      }
      // 同时显示本地预览
      const reader = new FileReader()
      reader.onload = (e) => {
        this.imageSrc = e.target.result
      }
      reader.readAsDataURL(file)
      this.loading = false
    },
    deleteImage() {
      this.imagePath = ''
      this.processing = false
      this.tips = false
      localStorage.removeItem('edit_picture')
      localStorage.removeItem('edit_picture_showimage')
    },
    // 应用函数
    start_process() {
      this.processedImage = ''
      if (this.imagePath === '' || this.imagePath === null) {
        Message.warning('请先选择图像文件')
        return
      }
      if (this.processing) {
        Message.warning('任务已在进行中，请勿重复提交以免造成错误!')
        return
      }
      // console.log(this.bolean_1, this.bolean_2)
      this.processing = true
      this.tips = '任务正在生成,预计等待13-15S.....'
      const seed = Math.floor(Math.random() * 10000000000000000)
      const filename = `["tmp-comfyui/${String(Date.now()) + String(random.int(1, 99999))}.png"]`
      const promptData = {
        13: {
          inputs: {
            blur: this.blur_2,
            image: [
              '29',
              0
            ]
          },
          class_type: 'AC_高斯模糊',
          _meta: {
            title: 'AC_高斯模糊'
          }
        },
        21: {
          inputs: {
            brightness: this.brightness,
            contrast: this.constrast,
            saturation: this.saturation,
            image: [
              '35',
              0
            ]
          },
          class_type: 'AC_颜色校正(亮度)',
          _meta: {
            title: 'AC_颜色校正(亮度)'
          }
        },
        27: {
          inputs: {
            soft: this.soft,
            threshold: this.threshold,
            opacity: this.opacity,
            image: [
              '21',
              0
            ]
          },
          class_type: 'AC_柔光',
          _meta: {
            title: 'AC_柔光'
          }
        },
        29: {
          inputs: {
            angle: this.angle,
            blur: this.blur_1,
            image: [
              '32',
              0
            ]
          },
          class_type: 'AC_动态模糊',
          _meta: {
            title: 'AC_动态模糊'
          }
        },
        30: {
          inputs: {
            seed: seed
          },
          class_type: 'easy seed',
          _meta: {
            title: 'EasySeed'
          }
        },
        31: {
          inputs: {
            text: '1098930206952732',
            anything: [
              '30',
              0
            ]
          },
          class_type: 'easy showAnything',
          _meta: {
            title: 'Show Any'
          }
        },
        32: {
          inputs: {
            image_url: this.imagePath
          },
          class_type: 'AC_从URL加载图像',
          _meta: {
            title: 'AC_从URL加载图像'
          }
        },
        33: {
          inputs: {
            filename: filename,
            access_key_id: OSS_ACCESS_KEY_ID,
            access_key_secret: OSS_ACCESS_KEY_SECRET,
            security_token: '',
            bucket_name: 'mj-comfy-ui',
            endpoint: 'oss-cn-shenzhen.aliyuncs.com',
            image: [
              '27',
              0
            ]
          },
          class_type: 'AC_Oss上传图像',
          _meta: {
            title: 'AC_Oss上传图像'
          }
        },
        34: {
          inputs: {
            boolean: this.bolean_1,
            on_true: [
              '29',
              0
            ],
            on_false: [
              '32',
              0
            ]
          },
          class_type: 'easy ifElse',
          _meta: {
            title: 'If else'
          }
        },
        35: {
          inputs: {
            boolean: this.bolean_2,
            on_true: [
              '13',
              0
            ],
            on_false: [
              '34',
              0
            ]
          },
          class_type: 'easy ifElse',
          _meta: {
            title: 'If else'
          }
        }
      }
      this.clientId = uuidv4()
      const data = {
        prompt: promptData,
        client_id: this.clientId
      }
      // 发送 Prompt 请求
      const sendPromptRequest = async () => {
        try {
          console.log('get prompt response', data)
          return genPrompt(data)
        } catch (error) {
          console.error('发送作图请求失败：', error)
          this.processing = false
          this.tips = false
          return null
        }
      }

      const fetchImageFilename = async (promptId) => {
        try {
          // 直接使用该实例请求历史记录
          const historyRequest = axios.create({
            baseURL: getLastUsedBaseUrl(),
            timeout: 5000,
            headers: {
              'Content-Type': 'application/json'
            }
          })

          const response = await historyRequest.get(`/history/${promptId}`)
          const promptInfo = response.data[promptId]
          // const response = await getImagePathByPrompt(promptId)
          // const promptInfo = response[promptId]
          const promptIndex = 2 // prompt信息的下标
          const inputIndex = 33 // prompt信息组件名的下标

          // console.log(promptInfo)
          if (promptInfo.status.status_str === 'success') {
            const tmp = JSON.parse(promptInfo.prompt[promptIndex][inputIndex].inputs.filename)

            const imagepath = genOssImage(tmp[0])
            localStorageUtils.setItem('edit_picture_showimage', imagepath)
            const info = {
              details: [{ path: imagepath }]
            }
            getTaskEnd({ result: JSON.stringify(info) }, this.taskLogId)
            this.processedImage = imagepath
            this.processing = false
            this.tips = false
          } else {
            console.error('获取历史记录失败，状态码：', response.status)
          }
        } catch (error) {
          console.error('获取图像文件名失败：', error)
        }
      }

      const listenToProgress = (promptId) => {
        this.ws = new WebSocket(`${getLastUsedBaseUrl()}/ws?clientId=${this.clientId}`)
        const wsTimeout = setTimeout(() => {
          Message.warning('网络连接超时,请重新尝试!')
          this.ws.close()
        }, 2000)

        this.ws.onopen = () => {
          console.log('提交服务器开始生成...')
          getTaskStart({
            type: EDIT_Image_PS,
            prompt: '',
            input_images: this.imagePath ? [this.imagePath] : []
          }).then(rep => {
            this.taskLogId = rep.data.task.id
          })
          clearTimeout(wsTimeout)
        }
        this.ws.onmessage = async (event) => {
          clearTimeout(wsTimeout)
          const data = event.data
          if (typeof data === 'string') {
            try {
              const msg = JSON.parse(event.data)
              console.log(`这是返回${msg}`)

              if (msg.type === 'executing') {
                const data = msg.data
                if (data.node === null && data.prompt_id === promptId) {
                  // console.log('执行完成')
                  this.ws.close()
                  await fetchImageFilename(promptId)
                }
              } else if (msg.type === 'progress') {
                const value = msg.data.value
                const max = msg.data.max
                const current = (value / max * 100).toFixed(2)
                this.tips = `大约完成：${current}%`
              }
            } catch (error) {
              console.log('获取结果失败，请重试')
              this.tips = false
            }
          }
        }
        this.ws.onclose = async () => {
          // console.log('与后台链接断开')
          this.processing = false
          this.tips = false
          try {
            // 恢复cuda为空闲状态
            const index = cudaIndexNum()
            // console.log('回复当前cuda状态', index)
            await cuda.changeCudaCurrentStatus(index, 'leisure')
          } catch (error) { console.log(error) }
        }
      }

      (async () => {
        const result = await sendPromptRequest()
        if (result && result.prompt_id) {
          listenToProgress(result.prompt_id)
        }
      })()
    },
    // 初始化效果
    source_html() {
      const main = document.querySelector('.image_area')
      main.style.opacity = this.theme === false ? 0.75 : 1
    }
  }
}
</script>
<style lang="less" scoped>
@import "@/style/common.less";
@import "@/assets/fonts/style.css";
@import "@/assets/font_sczlgzino/iconfont.css";

@keyframes ip_move {
  0% {
    padding-bottom: 5px;
  }

  50% {
    padding-bottom: 10px;
  }

  100% {
    padding-bottom: 5px;
  }
}

@keyframes opacity {
  0% {
    opacity: 0.4;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.4;
  }
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-family: "icomoon";
  overflow: hidden;
}

.active {
  transition: all 0.5s;
  background-color: @basicselect;
  color: @font_black;
}

.el-message--warning {
  background-color: #fff3cd !important;
  color: #856404 !important;
  border: 1px solid #ffeeba !important;
  font-weight: bold;
}

.iconfont {
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 25px;
}

.body {
  width: 100vw;
  height: calc(100vh -190px);
  color: @font_white;

  .image_area {
    display: flex;
    flex-direction: row;
    position: relative;
    width: 100%;
    height: calc(100vh - 190px);
    padding: 10px 30px 10px 30px;

    .gap {
      width: 15px;
    }

    .image_upload {
      position: relative;
      flex: 1;
      height: 100%;
      border-radius: 25px;
      background-color: @basicselect;
      cursor: pointer;
      overflow: hidden;
      transition: all 0.5s;

      &:hover {
        transition: all 0.5s;
        box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);
      }

      .tips {
        color: @font_black;
        position: absolute;
        font-size: 25px;
        top: 50%;
        left: 50%;
        transform: translateX(-50%);
        font-family: 'icomoon';
        z-index: 1;
        transition: all 0.5s;

        &:hover {
          font-size: 26px;
          transition: all 0.5s;
        }

        &:active {
          top: 48%;
          transition: all 0.5s;
          box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);
        }
      }

      img {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        outline: none;
        z-index: 2;
      }

      .delete_image {
        position: absolute;
        width: 200px;
        height: 60px;
        font-size: 25px;
        font-family: 'icomoon';
        text-align: center;
        line-height: 60px;
        background-color: @morejoy;
        color: @font_white;
        border-radius: 15px;
        top: 15px;
        right: 15px;
        z-index: 3;

        &:active {
          transition: all 0.5s;
          line-height: 50px;
        }
      }

      .paste {
        position: absolute;
        width: 200px;
        height: 60px;
        font-size: 25px;
        font-family: 'icomoon';
        text-align: center;
        line-height: 60px;
        color: @font_gray;
        border-radius: 15px;
        bottom: 15px;
        right: 15px;
        z-index: 5;
        transition: all 0.5s;

        &:active,
        &:hover {
          transition: all 0.5s;
          line-height: 50px;
        }
      }
    }

    .parameters {
      flex: 1;
      display: flex;
      flex-direction: column;
      position: relative;
      border-radius: 25px;
      align-items: center;
      height: calc(100vh - 190px);
      font-family: 'icomoon';
      gap: 10px 0;
      justify-content: center;

      .document {
        width: 520px;
        display: flex;
        font-weight: 500;

        .top_tips_01 {
          color: @font_gray;
          font-size: 24px;
          text-indent: 10px;
        }

        .video_tip {
          display: block;
          color: @morejoy;
          font-size: 24px;
          cursor: pointer;
        }
      }

      span {
        display: block;
        width: 500px;
        color: @font_gray;
        text-align: left;
        font-size: 23px;
      }

      .activeblur {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 500px;
        height: 165px;
        font-size: 25px;
        color: @font_black;
        background-color: @basicselect;
        border-radius: 15px;
        gap: 15px;
        transition: all 0.5s;
        cursor: pointer;

        .edit {
          display: flex;
          gap: 0 60px;

          input,
          select {
            width: 180px;
            height: 35px;
            font-size: 20px;
            border: 1px solid @basicselect;
            border-radius: 5px;
            text-align: center;
          }
        }

        &:hover {
          font-size: 27px;
          transition: all 0.5s;
          box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);

        }
      }

      .blur {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 500px;
        height: 115px;
        font-size: 25px;
        color: @font_black;
        background-color: @basicselect;
        border-radius: 15px;
        gap: 15px;
        transition: all 0.5s;
        cursor: pointer;

        .edit {
          display: flex;
          gap: 0 60px;

          input,
          select {
            width: 180px;
            height: 35px;
            font-size: 20px;
            border: 1px solid @basicselect;
            border-radius: 5px;
            text-align: center;
          }
        }

        &:hover {
          font-size: 27px;
          transition: all 0.5s;
          box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);

        }
      }

      .color,
      .portrait {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 500px;
        height: 165px;
        font-size: 25px;
        color: @font_black;
        background-color: @basicselect;
        border-radius: 15px;
        gap: 15px;
        transition: all 0.5s;
        cursor: pointer;

        .edit {
          display: flex;
          gap: 0 60px;

          input {
            width: 180px;
            height: 35px;
            font-size: 20px;
            border: 1px solid @basicselect;
            border-radius: 5px;
            text-align: center;
          }
        }

        &:hover {
          font-size: 27px;
          transition: all 0.5s;
          box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);

        }
      }

      .start {
        width: 500px;
        height: 80px;
        font-size: 25px;
        text-align: center;
        line-height: 80px;
        font-family: 'icomoon';
        border-radius: 15px;
        background-color: @basicselect;
        color: @font_black;
        cursor: pointer;
        transition: all 0.5s;

        &:hover {
          font-size: 27px;
          transition: all 0.5s;
          box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);

        }

        &:active {
          line-height: 60px;
          width: 420px;
          height: 110px;
          transition: all 0.5s;
        }
      }

      .disscuss_area {
        display: flex;
        width: 500px;
        height: 80px;
        gap: 10px;

        .disscuss {
          flex: 1;
          height: 80px;
          font-size: 25px;
          border-radius: @border_radius;
          background-color: @basicselect;
          text-align: center;
          line-height: 80px;
          color: @font_black;
          cursor: pointer;
          transition: all 0.5s;

          &:hover {
            font-size: 27px;
            transition: all 0.5s;
            box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);

          }
        }
      }
    }

    .panel {
      height: 100%;
      position: relative;
      flex: 1;
      border-radius: 25px;
      background-color: @basicselect;
      position: relative;
      overflow: hidden;
      cursor: pointer;
      transition: all 0.5s;

      &:hover {
        transition: all 0.5s;
        box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);
      }

      .show {
        position: absolute;
        border-radius: 15px;
        background-color: @morejoy;
        width: 200px;
        height: 60px;
        font-size: 25px;
        text-align: center;
        line-height: 60px;
        top: 25px;
        left: 25px;
        z-index: 5;
      }

      img {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        outline: none;
        z-index: 2;
      }

      .tips {
        position: absolute;
        width: 100%;
        height: 50px;
        font-size: 25px;
        top: 50%;
        left: 6%;
        text-align: center;
        line-height: 100%;
        transition: all 0.5s;
        color: @font_black;
        font-weight: 500;
        z-index: 4;
      }

      .mask {
        width: 100%;
        height: 100%;
        background-color: @font_gray;
        z-index: 3;
      }

      .copy_path {
        position: absolute;
        text-align: center;
        right: 10px;
        bottom: 10px;
        width: 120px;
        height: 50px;
        font-size: 25px;
        color: @font_gray;
        z-index: 4;
        transition: all 0.5s;

        &:hover {
          font-size: 27px;
        }
      }
    }
  }
}
</style>
